export * from './getaway-details-wrapper';
